import { writable } from 'svelte/store';

export type User = {
  id?: string;
  name?: string;
  picture?: string;
  email?: string;
  sharing?: string;
  verified?: boolean;
  sharedId?: string;
  shared?: boolean;
  sharedEmail?: string;
};

export const loading = writable<boolean>(true);

export function resetLoadingState() {
  loading.set(false);
}

export const user = writable<User | null>(null);

export function isUserLoggedIn(userObj: User): boolean {
  return !!userObj.id;
}
